import { ColumnCell, ColumnHeader } from './Components';

export const GeoColumn = {
  key: 'geo',
  header: () => <ColumnHeader className="w-32">Geography</ColumnHeader>,
  cell: ({ campaign }) => (
    <ColumnCell className="capitalize">{(campaign.geoSegments || []).length ? 'Custom' : 'Everywhere'}</ColumnCell>
  ),
};
